import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";

interface UserGroupCollectionOptions {
    organizationId: number
}

export class UserGroupCollection extends CachingCollection<Backbone.Model> {

    organizationId: number;

    url = () => {
        return window.location.origin + '/api/v1/organizations/' + this.organizationId + '/usergroups';
    };

    constructor(initialModels: Object[] | any[], options: UserGroupCollectionOptions) {
        super(initialModels, options);
        this.organizationId = options.organizationId;

    }

    comparator = (model) => {
        return model.get('name');
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/UserGroups.ts